import React from "react";

export default function About() {
	return (
		<section id="about">
			<div className="section-header">About</div>
			<p>
				I am a Lead Software Engineer with over a decade of experience
				designing, developing, and deploying enterprise applications across the
				finance, insurance, education, and payment industries. My work bridges
				complex backend systems and intuitive user interfaces.
			</p>
			<p>
				I specialize in full-stack web and API development with .NET 8 and Java
				17 (Spring Boot), modern architectures like DDD and CQRS, and
				microservices patterns. I’ve implemented asynchronous messaging with
				RabbitMQ and MassTransit, high-performance caching with Redis, and gRPC
				for service-to-service communication.
			</p>
			<p>
				On the frontend, I focus on scalable design systems and modular delivery
				using Angular (NX monorepo) and React, including Module Federation and
				Native Federation for dynamic feature loading. I’m hands-on with AWS
				(ECS, ECR, Lambda, API Gateway, S3, RDS) and CI/CD using
				CodeBuild/CodePipeline.
			</p>
			<p>
				I’m known for leadership, mentorship, and cross-team
				collaboration—aligning software quality with business outcomes and
				continuously improving delivery processes.
			</p>
		</section>
	);
}
